(() => {
  const carousels = new WeakMap();
  const homeCatalogs = new WeakSet();
  function mount(root = document) {
    const heroes = [...root.querySelectorAll('[data-carousel]')];
    if (root.matches?.('[data-carousel]')) heroes.unshift(root);
    heroes.forEach(hero => {
      if (carousels.has(hero)) return;
      const slides = [...hero.querySelectorAll('[data-slide]')];
      const buttons = [...hero.querySelectorAll('[data-to]')];
      const pause = hero.querySelector('[data-pause]');
      const interval = Math.max(5, Math.min(15, Number(hero.dataset.interval) || 8)) * 1000;
      let active = 0, paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      let focused = false, hovered = false, editorSelected = false, timer;
      const show = index => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, index) => slide.hidden = index !== active);
        buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (!paused && !focused && !hovered && !editorSelected && !document.hidden && slides.length > 1) timer = setInterval(() => show(active + 1), interval);
      };
      const updatePause = () => {
        if (!pause) return;
        pause.textContent = paused ? '▷' : 'Ⅱ';
        pause.setAttribute('aria-pressed', String(paused));
      };
      buttons.forEach(button => button.onclick = () => { show(Number(button.dataset.to)); start(); });
      if (pause) pause.onclick = () => { paused = !paused; updatePause(); start(); };
      hero.addEventListener('mouseenter', () => { hovered = true; stop(); });
      hero.addEventListener('mouseleave', () => { hovered = false; start(); });
      hero.addEventListener('focusin', () => { focused = true; stop(); });
      hero.addEventListener('focusout', event => { focused = hero.contains(event.relatedTarget); start(); });
      document.addEventListener('visibilitychange', start);
      carousels.set(hero, {
        select(slide) { editorSelected = true; stop(); show(slides.indexOf(slide)); },
        deselect() { editorSelected = false; start(); },
        destroy() { stop(); document.removeEventListener('visibilitychange', start); }
      });
      show(0); updatePause(); start();
    });
    const catalogs = [...root.querySelectorAll('[data-home-catalog]')];
    if (root.matches?.('[data-home-catalog]')) catalogs.unshift(root);
    catalogs.forEach(catalog => {
      if (homeCatalogs.has(catalog)) return;
      const items = [...catalog.querySelectorAll('[data-home-category]')];
      const buttons = [...catalog.querySelectorAll('[data-home-filter]')];
      const limit = Math.max(1, Number(catalog.dataset.homeLimit) || 8);
      const empty = catalog.querySelector('[data-home-empty]');
      const filter = category => {
        let matched = 0, visible = 0;
        items.forEach(item => {
          const matches = category === 'all' || item.dataset.homeCategory === category;
          if (matches) matched++;
          const show = matches && (category !== 'all' || visible < limit);
          item.hidden = !show;
          if (show) visible++;
        });
        buttons.forEach(button => {
          const selected = button.dataset.homeFilter === category;
          button.classList.toggle('active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        catalog.classList.toggle('is-filtered', category !== 'all');
        if (empty) empty.hidden = matched > 0;
      };
      buttons.forEach(button => button.onclick = () => filter(button.dataset.homeFilter));
      homeCatalogs.add(catalog);
      filter('all');
    });
    root.querySelectorAll('.menu-toggle').forEach(menu => {
      const nav = document.getElementById(menu.getAttribute('aria-controls'));
      if (!nav) return;
      menu.onclick = () => { const open = nav.hidden; nav.hidden = !open; menu.setAttribute('aria-expanded', String(open)); };
    });
    root.querySelectorAll('[data-localization]').forEach(input => input.onchange = () => input.form.submit());
    root.querySelectorAll('[data-image]').forEach(button => button.onclick = () => {
      const gallery = button.closest('[data-product-gallery]');
      const image = gallery?.querySelector('.main-product-photo img');
      if (!image) return;
      image.src = button.dataset.image; image.removeAttribute('srcset'); image.alt = button.dataset.alt || image.alt;
      gallery.querySelectorAll('[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
    const params = new URLSearchParams(location.search), field = root.querySelector('[data-product-code]'), id = params.get('product');
    if (field && id && /^[a-z0-9-]{1,80}$/.test(id)) field.value = id.replace(/^keeping-/, '').toUpperCase();
    if (params.get('sample') && field) { const sample = field.dataset.sampleText || 'Sample request'; field.value = field.value ? field.value + ' · ' + sample : sample; }
  }
  const chat = document.querySelector('.chat-toggle'), panel = document.querySelector('#keeping-chat-panel');
  const toggleChat = open => { if (!panel || !chat) return; panel.hidden = !open; chat.setAttribute('aria-expanded', String(open)); };
  if (chat) chat.onclick = () => toggleChat(panel.hidden);
  document.querySelector('.close-chat')?.addEventListener('click', () => toggleChat(false));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    toggleChat(false);
    const nav = document.querySelector('#keeping-mobile-menu'), menu = document.querySelector('.menu-toggle');
    if (nav && menu) { nav.hidden = true; menu.setAttribute('aria-expanded', 'false'); }
  });
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-carousel]').forEach(hero => carousels.get(hero)?.destroy()));
  document.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-slide]'); if (slide) carousels.get(slide.closest('[data-carousel]'))?.select(slide); });
  document.addEventListener('shopify:block:deselect', event => { const slide = event.target.closest('[data-slide]'); if (slide) carousels.get(slide.closest('[data-carousel]'))?.deselect(); });
})();
